"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _fields = require("../../fields");

var _phoneNumberConfig = require("./phoneNumberConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var PhoneNumberDefinition = _flowRuntime["default"].tdz(function () {
  return _phoneNumberConfig.PhoneNumberDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("phoneNumber", _flowRuntime["default"].ref(PhoneNumberDefinition))));

var _default = function _default(_arg) {
  var phoneNumber = _arg.phoneNumber;
  return phoneNumber.options ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, phoneNumber.options.mobile && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
    key: _phoneNumberConfig.mobile.key,
    textfield: _phoneNumberConfig.mobile,
    inheritedFieldValidation: phoneNumber.inheritedFieldValidation
  }), phoneNumber.options.home && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
    key: _phoneNumberConfig.home.key,
    textfield: _phoneNumberConfig.home,
    inheritedFieldValidation: phoneNumber.inheritedFieldValidation
  }), phoneNumber.options.work && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
    key: _phoneNumberConfig.work.key,
    textfield: _phoneNumberConfig.work,
    inheritedFieldValidation: phoneNumber.inheritedFieldValidation
  })) : null;
};

exports["default"] = _default;